<template>
  <div class="cursos">
    <Header/>
    <div>
      <img src="../assets/img/projetos.jpg" alt="Avatar" style="border-bottom-right-radius:20px;border-bottom-left-radius:20px;width:100%;height:80%;">
    </div>
      <div class="body">
        <div class="sobre">
  <b-tabs content-class="mt-3" fill>
            <b-tab title="Projeto Canguru" active>
              <div class="div_tam">
                <h4 class="p_sobre">Projeto Canguru</h4>
                <p class="p_sobre"> Aqui no Sapiência Pré-vestibular você nunca está sozinho: temos o Projeto Canguru, um momento para ACOMPANHAMENTO INDIVIDUAL dos seus estudos a cada 15 dias. Você terá um PROFESSOR TUTOR que te acompanhará do início ao fim. Depois de cada simulado, há o acompanhamento do seu rendimento e a indicação do que deve ser seu foco nas próximas semanas.</p>
                <p class="p_sobre"> No Canguru,  também te ensinamos a estudar da maneira que você mais se adaptar. Não importa se você é visual, auditivo ou sinestésico; se você gosta de mapa mental, resumo ou organograma. Indicamos o que é melhor para você e montamos um PLANO DE ESTUDOS PERSONALIZADO.</p>
                <p class="p_sobre">É nesse momento também que treinaremos com você os conteúdos de possíveis lacunas escolares que você tenha e conteúdos interdisciplinares, pensando em vestibulares com o ENEM, a UNICAMP e a UFPR. Venha aprender que ESTUDAR NÃO PRECISA SER CANSATIVO!!</p>
              </div>
            </b-tab>
            <b-tab title="Humanidades">
              <div class="div_tam">
                <h4 class="p_sobre">Simulados</h4>
                <p class="p_sobre">
                Está cansado de treinar provas que não são o seu foco? O lugar que você estuda só trabalha com simulados Fuvest, Enem e Unicamp? Venha ESCOLHER O TIPO DE SIMULADO QUE VOCÊ QUER TREINAR!!</p>
                <p class="p_sobre">No Cursinho Sapiência, você treina especificamente o que quer com SIMULADOS PERSONALIZADOS feitos a cada 15 dias. Quem escolhe o modelo de vestibular (públicos ou privados) para treinar e o formato deste (teste ou dissertativo) é você!! E ainda: para cada simulado, você recebe UM RENDIMENTO GERAL E TAMBÉM POR DISCIPLINA para saber onde evoluiu e onde precisa melhorar!!</p>
                <p class="p_sobre">Venha fazer parte de um cursinho que foca especificamente no seu sonho!! Vem pro Sapiência!!  </p>
              </div>
            </b-tab>
            <b-tab title="Metodologia Ativa">
              <div class="div_tam">
                <h4 class="p_sobre">Metodologia Ativa</h4>
                <p class="p_sobre">
                Mas o que é metodologia ativa?</p>
                <p class="p_sobre">Metodologia ativa é justamente o deslocamento do aluno em situação de passividade com o aprendizado para uma postura ativa em busca do conhecimento. As aulas PBL visam tirar o aluno da zona de conforto e fazer com que ele exerça uma posição de protagonismo frente ao seu aprendizado, dentre as diferentes aulas de metodologia ativa temos: sala de aula invertida, reconhecimento de meio, aprendizagem baseada em projetos, gamificação e aprendizagem baseada em problemas. Aprender vivendo e experimentando é mergulhar no conhecimento e nunca mais esquecer.</p>
              </div>
            </b-tab>
          </b-tabs>
        </div>
        
        <!-- <div class="teste">
          <div class="item">
            <h4 class="p_material">Projeto Canguru</h4>
            <p class="p_sobre"> Aqui no Sapiência Pré-vestibular você nunca está sozinho: temos o Projeto Canguru, um momento para ACOMPANHAMENTO INDIVIDUAL dos seus estudos a cada 15 dias. Você terá um PROFESSOR TUTOR que te acompanhará do início ao fim. Depois de cada simulado, há o acompanhamento do seu rendimento e a indicação do que deve ser seu foco nas próximas semanas.</p>
            <p class="p_sobre"> No Canguru,  também te ensinamos a estudar da maneira que você mais se adaptar. Não importa se você é visual, auditivo ou sinestésico; se você gosta de mapa mental, resumo ou organograma. Indicamos o que é melhor para você e montamos um PLANO DE ESTUDOS PERSONALIZADO.</p>
            <p class="p_sobre">É nesse momento também que treinaremos com você os conteúdos de possíveis lacunas escolares que você tenha e conteúdos interdisciplinares, pensando em vestibulares com o ENEM, a UNICAMP e a UFPR. Venha aprender que ESTUDAR NÃO PRECISA SER CANSATIVO!!</p>
          </div>
          <div class="item" >
            <h4 class="p_material">Simulados</h4>
            <p class="p_sobre">
              Está cansado de treinar provas que não são o seu foco? O lugar que você estuda só trabalha com simulados Fuvest, Enem e Unicamp? Venha ESCOLHER O TIPO DE SIMULADO QUE VOCÊ QUER TREINAR!!</p>
            <p class="p_sobre">No Cursinho Sapiência, você treina especificamente o que quer com SIMULADOS PERSONALIZADOS feitos a cada 15 dias. Quem escolhe o modelo de vestibular (públicos ou privados) para treinar e o formato deste (teste ou dissertativo) é você!! E ainda: para cada simulado, você recebe UM RENDIMENTO GERAL E TAMBÉM POR DISCIPLINA para saber onde evoluiu e onde precisa melhorar!!</p>
            <p class="p_sobre">Venha fazer parte de um cursinho que foca especificamente no seu sonho!! Vem pro Sapiência!!  </p>
          </div>
        </div> -->
    </div>
  <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

export default{
  components:{
    Header,
    Footer
  }
}
</script>

<style>
@import "../assets/style_padrao.css";
  .teste{
    background: white;
    -webkit-box-shadow:  0 0 2px 2px lightgray;
    box-shadow: 0 0 2px 2px lightgray;
    border-radius: 25px;
    width: 95%;
    height: auto;
    margin-top:-5%;
    /* margin-top: -10rem; */
    margin-bottom: 5%;
    padding-top: 5%;
  }
  #t{
    position: absolute;
    left: 35%;
    bottom: 75%;
    z-index: 1000;
    background: #7435af;
    margin: auto;
    border-radius: 20px;
    padding: 2% 5%;
    width: fit-content;
  }
  #a{
    position: relative;
    padding-top: 7%;
    border-radius: 25px;
    background:white;
    box-shadow: 2px 3px 18px #adadad;
  }
  #sap_aluno{
    width: 100%;
    margin-bottom: 5%;
  }
  #ast{
    color:red;
  }
  h1{
    text-align: center;
  }
  h2{
    text-align: center;
  }
  .p_sobre{
    margin-left: 4%;
    margin-right: 4%;
    text-align: justify!important;
    color: #4F4F4F;
  }
  #msg{
    text-align: center;
  }
  @media only screen and (max-width: 450px) {
    .p_sobre{
      text-align: left!important;
    }
  }
</style>
